import React from 'react'
import { useLocation, useParams } from 'react-router-dom'
import SingleRoundHostcupFirebase from '../components/Hostcup/HostcupAdminFirebase/HostcupDetails/SingleRoundHostcupFirebase'

function SingleRoundHostcupFirebasePage() {

    const {id} = useParams()

    function useQuery() {
        return new URLSearchParams(useLocation().search);
    }
    let query = useQuery();

    console.log(query.get("runde"), "QUERY")

    const roundId = query.get("runde")

    return (
        <div className="container my-3">
            <SingleRoundHostcupFirebase id={id} roundId={roundId} type="page" />
        </div>
    )
}
export default SingleRoundHostcupFirebasePage